import { AbstractControl } from '@angular/forms';

export function housenumberValidator(control: AbstractControl): { [key: string]: any } | null {
  const valid = /^[0-9]{1,6}$/i.test(control.value);
  return valid ? null : { invalidValue: { valid: false, value: control.value } };
}
